import { IStudentProfile } from "../typings/IStudentProfile";
import http, { gw } from "./client"

async function byId(userId?: string | number) {
  const response = await http.get(`/api/profile`, {
    params: {
      user_id: userId,
    }});
  return response.data;
}

async function update(profile: IStudentProfile) {
  const profileOnly = { ...profile }; //TO DO разобраться с дублированием полей в IStudentProfile
  delete profileOnly.email;
  delete profileOnly.name;
  delete profileOnly.avatar;
  const response = await http.post(`/api/profile`,
      { ...profileOnly },
      {
       params: {
        user_id: profile.id
       }
      }
    )
  return response.data;
}

export interface ExtendedAuthPasswordData {
  password: string; // текущий пароль,
  new_password: string;
  new_password_repeat: string;
  extended_auth: boolean;
}

async function changePassowrd(data: ExtendedAuthPasswordData) {
  const response = await http.post('/api/profile/change-password', data);
  return response.data
}

async function remove(userId: string | number) {
  const response = await http.get('/api/user/deleteaccount', {
    params: {
      user_id: userId
    },
  });
  return response.data;
}

interface IDoubleAuthResponse {
  type: T2FA
}
interface IGoogleAuth extends IDoubleAuthResponse {
  type: 'google'
  secretKey: string;
  qrCode: string;
}

interface ISmsAuth {
  type: 'sms'
  retryTimeout: number;
}

type T2FAResonpose = IGoogleAuth | ISmsAuth

async function change2fa(type: T2FA) {
  const response = await http.post<T2FAResonpose>('/api/profile/two-factor-auth', {type});
  return {
    type,
    ...response.data
  };
}

async function verifyGoogleAuth(data: {verifyCode: string; secretKey: string}) {
  const response = await http.post<T2FAResonpose>('/api/profile/two-factor-auth', {
    type: 'google',
    ...data
  });
  return response;
}

async function validatePhone(phone: string) {
  const response = await http.get(`/api/phones/validate`, {
    params: { phone },
  });
  return response.data;
}

async function confirmPhone(confirmationData: {phone: string, code?: string | number, email: string}): Promise<{
  status: "success"
  message: string
  confirmToken: string
}> {
  const response = await gw.post('/api/account/phoneconfirm', {
    ...confirmationData,
    consumer: "at",
  })
  return response.data;
}

async function checkPhone(phone: string, email: string): Promise<{
  status: "success"
  message: string
  expires: string
}> {
  const response = await gw.post('/api/account/phonecheck', {
    consumer: "at",
    email: email,
    justverify: "no",
    phone: phone
  });
  return response.data;
}

async function updateNotificationSettings(notifications: IStudentProfile['notifications'], userId?: string | number) {
  const response = await http.post('/api/profile/notifications', {notifications}, {
    params: {
      user_id: userId,
    }
  });
  return response.data;
}


const profile = {
  change2fa, 
  validatePhone,
  verifyGoogleAuth,
  checkPhone,
  confirmPhone, 
  byId, 
  updateNotificationSettings, 
  update, 
  changePassowrd,
  remove,
}
export default profile